/**
 * Header behaviours: sticky show/hide on scroll, header height CSS variable,
 * mega menu hover intent on pointer devices.
 */
class HeaderComponent extends HTMLElement {
  connectedCallback() {
    this.sticky = this.dataset.sticky;
    this.lastScroll = window.scrollY;
    this.updateHeight();
    this.resizeObserver = new ResizeObserver(() => this.updateHeight());
    this.resizeObserver.observe(this);

    if (this.sticky !== 'none') {
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
    }

    this.initMegaMenus();
    this.initTransparent();
  }

  initTransparent() {
    if (!this.hasAttribute('data-transparent')) return;
    const first = document.querySelector('#MainContent > .shopify-section');
    const hero = first?.querySelector(':scope > .full-width, :scope > .video-hero, :scope > .parallax-banner, :scope > .slideshow, :scope > .collection-banner--hero');
    const ok = !!hero;
    this.classList.toggle('is-over-hero', ok);
    document.body.classList.toggle('header-transparent-active', ok);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    this.resizeObserver?.disconnect();
  }

  updateHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
  }

  onScroll() {
    const current = window.scrollY;
    const stuck = current > 4;
    this.classList.toggle('is-stuck', stuck);

    if (this.sticky === 'scroll-up') {
      const openMenu = this.querySelector('details[open]');
      if (openMenu) return;
      const goingDown = current > this.lastScroll && current > this.offsetHeight * 1.5;
      this.classList.toggle('is-hidden', goingDown);
    }
    this.lastScroll = current;
  }

  initMegaMenus() {
    if (!window.matchMedia('(hover: hover)').matches) return;
    this.querySelectorAll('details.header__menu').forEach((details) => {
      let timer;
      const summary = details.querySelector('summary');
      const open = () => {
        clearTimeout(timer);
        this.querySelectorAll('details.header__menu[open]').forEach((other) => other !== details && other.removeAttribute('open'));
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      };
      const close = () => {
        timer = setTimeout(() => {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }, 120);
      };
      details.addEventListener('mouseenter', open);
      details.addEventListener('mouseleave', close);
      summary.addEventListener('click', (event) => {
        // On hover devices the summary acts as a link-less toggle; keep keyboard behaviour intact.
        if (event.detail === 0) return;
        event.preventDefault();
        if (details.open) {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        } else {
          open();
        }
      });
    });
  }
}
if (!customElements.get('header-component')) customElements.define('header-component', HeaderComponent);
document.addEventListener('shopify:section:load', () => document.querySelector('header-component')?.initTransparent?.());
